import { z } from 'zod/v4';

export interface IPersonDto {
  firstName: string;
  lastName: string;
  birthDate: Date;
  street: string;
  houseNumber: string;
  postCode: string;
  city: string;
  country: string;
}

export const PERSON_SCHEMA: z.ZodType<IPersonDto> = z.object({
  firstName: z.string(),
  lastName: z.string(),
  birthDate: z.date(),
  street: z.string(),
  houseNumber: z.string(),
  postCode: z.string(),
  city: z.string(),
  country: z.string(),
});
